import { Modal, Button } from "antd";
import { useGetAPIMastersGetStudentIDCardDetails } from "../../../Generated/orval-apis/masters/masters";
import { ApiUtility } from "../../../Utilities/ApiUtility.axios";
import { useContext, useState } from "react";
import { adminContext } from "../../../Common/PageRoute";
import dayjs from "dayjs";
import ConfirmationModel from "../../../Common/ConfirmationModel";

interface GenerateCardProps {
  visible: boolean;
  onCancel: () => void;
  studentIds: string[];
  onDownloaded: () => void;
}

const GenerateCard: React.FC<GenerateCardProps> = ({
  visible,
  onCancel,
  studentIds,
  onDownloaded,
}) => {
  const { openNotification } = useContext(adminContext);
  const [dLoading, setDLoading] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const { data: studentDetails, isLoading } =
    useGetAPIMastersGetStudentIDCardDetails(
      {
        StudentIds: studentIds?.join(",") || "",
      },
      {
        query: { enabled: visible && !!studentIds },
      }
    );

  const handleDownloadIdCard = async () => {
    try {
      setDLoading(true);
      await ApiUtility.downloadFile("/Masters/DownloadCardsPdf", {
        studentIds: studentIds?.join(",") || "",
      });
      openNotification("success", "Download Card Successfully");
      setModalOpen(false);
      onDownloaded?.();
    } catch (err) {
      console.error("Download failed:", err);
      openNotification("error", "Failed to download card");
    } finally {
      setDLoading(false);
      setModalOpen(false);
    }
  };

  return (
    <>
      <Modal
        title="Student ID Card"
        open={visible}
        onCancel={onCancel}
        width="1386px"
        style={{ top: 30 }}
        loading={isLoading}
        footer={[
          <Button key="print" type="primary" onClick={() => setModalOpen(true)}>
            Print ID Card
          </Button>,
          <Button key="cancel" onClick={onCancel} disabled={dLoading}>
            Cancel
          </Button>,
        ]}
      >
        {studentDetails?.result && studentDetails?.result?.length > 0 ? (
          <div
            style={{
              border: "0.5px solid #bdb6b6ff",
              borderRadius: "8px",
              padding: "4px",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div
              id="wrapper-container"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "24px",
                justifyContent: "flex-start",
                overflowX: "hidden",
              }}
            >
              {studentDetails?.result?.map((student, index) => (
                <div
                  key={index}
                  className="flex-container"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "200px",
                    gap: "20px",
                  }}
                >
                  {/* Front Card */}
                  <div
                    className="card front-card"
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <img
                      src="/Card-Front.svg"
                      alt="Card Front"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                    <img
                      className="profile-image"
                      src={
                        student?.profile?.path || "/assets/default-profile.jpeg"
                      }
                      alt=""
                      style={{
                        position: "absolute",
                        width: "77px",
                        height: "77px",
                        borderRadius: "50%",
                        top: "80.4px",
                        left: "57.8px",
                        objectFit: "cover",
                        border: "2px solid white",
                      }}
                    />
                    <p
                      className="profile-name"
                      style={{
                        position: "absolute",
                        fontSize: "14px",
                        fontWeight: "bold",
                        textAlign: "center",
                        top: "162px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        margin: 0,
                        color: "#333",
                        width: "100%",
                      }}
                    >
                      {student?.name || "N/A"}
                    </p>
                    <p
                      className="dept-name"
                      style={{
                        position: "absolute",
                        fontSize: "10px",
                        fontWeight: "bold",
                        top: "182px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        margin: 0,
                        color: "#333",
                      }}
                    >
                      {student?.courseName || "N/A"}
                    </p>
                    <p
                      className="id-number"
                      style={{
                        position: "absolute",
                        top: "210px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        color: "white",
                        fontSize: "17px",
                        userSelect: "none",
                        margin: 0,
                        fontWeight: 500,
                      }}
                    >
                      {student?.studentId || "N/A"}
                    </p>
                    <p
                      className="batch-number"
                      style={{
                        position: "absolute",
                        fontSize: "8px",
                        fontWeight: 600,
                        top: "245px",
                        left: "80px",
                        margin: 0,
                        color: "#333",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {student?.batchName || "N/A"}
                    </p>
                    <p
                      className="DOB"
                      style={{
                        position: "absolute",
                        fontSize: "8px",
                        fontWeight: 600,
                        top: "260px",
                        left: "80px",
                        margin: 0,
                        color: "#333",
                        textAlign: "left",
                      }}
                    >
                      {student?.dob
                        ? dayjs(student?.dob).format("DD MMM YYYY")
                        : "N/A"}
                    </p>
                  </div>

                  {/* Back Card */}
                  <div
                    className="card back-card"
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <img
                      src="/Card-Back.svg"
                      alt="Card Back"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                    <p
                      className="presentAdd"
                      style={{
                        position: "absolute",
                        top: "98px",
                        left: "42px",
                        width: "168px",
                        fontSize: "7px",
                        lineHeight: "1.1",
                        margin: 0,
                        color: "#333",
                      }}
                    >
                      {student?.contactDetail?.currentAddress || "N/A"}
                    </p>
                    <p
                      className="permAdd"
                      style={{
                        position: "absolute",
                        top: "145px",
                        left: "42px",
                        width: "150px",
                        fontSize: "7px",
                        lineHeight: "2",
                        margin: 0,
                        color: "#333",
                      }}
                    >
                      {student?.contactDetail?.permanentAddress || "N/A"}
                    </p>
                    <p
                      className="phn"
                      style={{
                        position: "absolute",
                        top: "186px",
                        left: "100px",
                        width: "160px",
                        fontSize: "7px",
                        lineHeight: "1.1",
                        marginLeft: "2px",
                        color: "#333",
                      }}
                    >
                      {student?.guardianPhone || "N/A"}
                    </p>
                    <p
                      className="compAdd"
                      style={{
                        position: "absolute",
                        top: "236px",
                        left: "42px",
                        width: "160px",
                        fontSize: "7px",
                        lineHeight: "2",
                        margin: 0,
                        color: "#333",
                      }}
                    >
                      H 298-299, 3rd Phase
                      <br />
                      RIICO Industrial Area, Bornada
                      <br />
                      Jodhpur - 342012 (Raj) India
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p>No student details found. Please try again.</p>
          </div>
        )}
      </Modal>

      <ConfirmationModel
        open={modalOpen}
        onOk={handleDownloadIdCard}
        onCancel={() => setModalOpen(false)}
        text="Are you sure you want to print the student ID card(s)?"
        parentLoading={dLoading}
      />
    </>
  );
};

export default GenerateCard;
